export interface AnalyticsEventContext {
  workspace_id?: string;
  workspace_name?: string;
  org_id?: string;
  org_name?: string;
  plan_name?: string;
  property_id?: string;
  property_name?: string;
  property_area_hectares?: string;
}

let currentContext: AnalyticsEventContext = {};

// Replace rather than merge so switching routes cannot retain the previous org/property.
export function setAnalyticsEventContext(context: AnalyticsEventContext) {
  currentContext = { ...context };
}

export function getAnalyticsEventContext(): AnalyticsEventContext {
  return { ...currentContext };
}
